export default __webpack_public_path__ + "static/media/photo15.762e007b.jpg";